module.exports = __webpack_public_path__ + "static/img/Real-time.3dab3a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Real-time.png
// module id = 1293
// module chunks = 7